export function initMap() {
  const mapStyle = [
      {
         featureType: "all",
         elementType: "labels",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "administrative",
         elementType: "labels",
         stylers: [
            {
               visibility: "on",
            },
         ],
      },
      {
         featureType: "administrative",
         elementType: "labels.text.fill",
         stylers: [
            {
               color: "#090909",
            },
            {
               visibility: "on",
            },
         ],
      },
      {
         featureType: "administrative.neighborhood",
         elementType: "labels",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "landscape",
         elementType: "all",
         stylers: [
            {
               visibility: "on",
            },
            {
               color: "#f9f8f6",
            },
         ],
      },
      {
         featureType: "landscape",
         elementType: "labels",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "poi",
         elementType: "all",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "poi",
         elementType: "labels",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "poi.park",
         elementType: "geometry",
         stylers: [
            {
               color: "#f9f8f6",
            },
            {
               visibility: "on",
            },
         ],
      },
      {
         featureType: "road",
         elementType: "all",
         stylers: [
            {
               saturation: -100,
            },
            {
               lightness: 45,
            },
         ],
      },
      {
         featureType: "road",
         elementType: "geometry.fill",
         stylers: [
            {
               visibility: "on",
            },
            {
               color: "#090909",
            },
         ],
      },
      {
         featureType: "road",
         elementType: "labels",
         stylers: [
            {
               visibility: "on",
            },
         ],
      },
      {
         featureType: "road",
         elementType: "labels.text",
         stylers: [
            {
               visibility: "on",
            },
            {
               color: "#000000",
            },
         ],
      },
      {
         featureType: "road",
         elementType: "labels.text.fill",
         stylers: [
            {
               color: "#000000",
            },
         ],
      },
      {
         featureType: "road",
         elementType: "labels.text.stroke",
         stylers: [
            {
               color: "#ffffff",
            },
         ],
      },
      {
         featureType: "road.highway",
         elementType: "all",
         stylers: [
            {
               visibility: "simplified",
            },
         ],
      },
      {
         featureType: "road.highway",
         elementType: "labels",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "road.highway",
         elementType: "labels.text",
         stylers: [
            {
               visibility: "on",
            },
            {
               color: "#000000",
            },
         ],
      },
      {
         featureType: "road.highway",
         elementType: "labels.text.stroke",
         stylers: [
            {
               color: "#ffffff",
            },
         ],
      },
      {
         featureType: "road.arterial",
         elementType: "labels",
         stylers: [
            {
               visibility: "on",
            },
         ],
      },
      {
         featureType: "road.arterial",
         elementType: "labels.text",
         stylers: [
            {
               visibility: "on",
            },
            {
               color: "#000000",
            },
         ],
      },
      {
         featureType: "road.arterial",
         elementType: "labels.text.stroke",
         stylers: [
            {
               visibility: "on",
            },
            {
               color: "#ffffff",
            },
         ],
      },
      {
         featureType: "road.arterial",
         elementType: "labels.icon",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "transit",
         elementType: "all",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "transit",
         elementType: "labels",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
      {
         featureType: "water",
         elementType: "all",
         stylers: [
            {
               color: "#eeebe4",
            },
            {
               visibility: "on",
            },
         ],
      },
      {
         featureType: "water",
         elementType: "labels",
         stylers: [
            {
               visibility: "off",
            },
         ],
      },
   ];

  window.addEventListener('load', () => {
      const mapEl = document.querySelector('#map');
      if (mapEl) {
          initializeDynamicMap(mapEl);
      }
  });

   async function initializeDynamicMap(mapEl) {
      const coordsData = mapEl.getAttribute('data-coords');
      const isMulti = coordsData.trim().startsWith('[');
      let locations = [];

      try {
         locations = isMulti ? JSON.parse(coordsData) : [{ Coords: coordsData }];
      } catch (e) {
         console.error('Failed to parse map coordinates:', e);
         return;
      }

      const iconSource = window.location.pathname.split("/").slice(0, 2).join("/") + // comment this out when going live
         "/wp-content/themes/enertek/assets/images/marker.png";

      const firstCoords = locations[0].Coords.split(',');
      const centerLatLng = new google.maps.LatLng(
         parseFloat(firstCoords[0]),
         parseFloat(firstCoords[1])
      );

      const greeceCenter = new google.maps.LatLng(39.0742, 21.8243);

      const map = new google.maps.Map(mapEl, {
         zoom: isMulti ? 6 : 15,
         center: isMulti ? greeceCenter : centerLatLng,
         gestureHandling: 'cooperative',
         mapTypeId: google.maps.MapTypeId.ROADMAP,
         styles: mapStyle,
         scrollwheel: false,
      });

      const markers = locations.map((location) => {
         const [lat, lng] = location.Coords.split(',').map((c) => parseFloat(c.trim()));
         const latLng = new google.maps.LatLng(lat, lng);

         const marker = new google.maps.Marker({
               position: latLng,
               map,
               title: location.Title || '',
               icon: {
                  url: iconSource,
                  scaledSize: new google.maps.Size(30, 30),
                  anchor: new google.maps.Point(15, 30),
               },
         });

         return marker;
      });

      // Black cluster renderer
      const renderer = {
         render({ count, position }) {
               return new google.maps.Marker({
                  position,
                  label: {
                     text: String(count),
                     color: 'white',
                     fontSize: '13px',
                     fontWeight: 'bold',
                  },
                  icon: {
                     path: google.maps.SymbolPath.CIRCLE,
                     fillColor: '#000000',
                     fillOpacity: 1,
                     strokeWeight: 2,
                     scale: 22,
                  },
                  zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
               });
         },
      };

      new markerClusterer.MarkerClusterer({ map, markers, renderer });

   }
}
